// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___H6Q0d","containerTextBox":"style__containerTextBox___3dL4z"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/carousel/basic/center-badge/style.css
// module id = 1456
// module chunks = 0